module.exports = __webpack_public_path__ + "img/_MG_8643.d6db90af.jpg";